import { render } from "./OwnerDirectoryPanel.vue?vue&type=template&id=3bf2a2f0&scoped=true"
import script from "./OwnerDirectoryPanel.vue?vue&type=script&lang=js"
export * from "./OwnerDirectoryPanel.vue?vue&type=script&lang=js"

import "./OwnerDirectoryPanel.vue?vue&type=style&index=0&id=3bf2a2f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf2a2f0"]])

export default __exports__